/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Detail_Last_ModifiedInputs */

const en_users_detail_last_modified = /** @type {(inputs: Users_Detail_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Modified`)
};

const pt_br2_users_detail_last_modified = /** @type {(inputs: Users_Detail_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última modificação`)
};

/**
* | output |
* | --- |
* | "Last Modified" |
*
* @param {Users_Detail_Last_ModifiedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_detail_last_modified = /** @type {((inputs?: Users_Detail_Last_ModifiedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Detail_Last_ModifiedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_detail_last_modified(inputs)
	return pt_br2_users_detail_last_modified(inputs)
});